import WeldIconSmall from "../icons/WeldIconSmall";

export const WeldLoader = () => (
  <div className="grid min-h-screen place-items-center">
    <WeldIconSmall className="w-8 animate-spin-slow fill-current dark:text-white" />
  </div>
);
